import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/apiClient';

export interface DashboardStats {
  window_days: number;
  currency: string;
  total_sales: number;
  order_count: number;
  avg_order_value: number;
  top_products: { title: string; units: number }[];
}

export function useDashboardStats() {
  return useQuery({
    queryKey: ['dashboard', 'stats'],
    queryFn: () => apiRequest<DashboardStats>('/api/v2/dashboard/stats'),
    staleTime: 60_000,
  });
}
